import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { CheckboxIcon } from './utils/CheckboxIcon.js';
import { checkboxStyles } from './utils/checkboxStyles.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const CheckboxStyled = styled.span(({ theme: { olist: { components: { checkbox }, }, }, }) => css `
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: 20px;
    width: 20px;
    background-color: ${checkbox.checkmark.background};
    border: ${checkbox.checkmark.border.width} solid
      ${checkbox.checkmark.border.color};
    border-radius: ${checkbox.checkmark.radius};
    pointer-events: none;
    box-sizing: border-box;
  `);
const Field = styled.input(({ error, indeterminate, theme }) => css `
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    left: 0;
    opacity: 0;
    margin: 0;
    cursor: pointer;

    transform: translateY(-50%);

    &:hover ~ ${CheckboxStyled} {
      ${checkboxStyles(theme, 'hover')}
    }

    &:focus ~ ${CheckboxStyled} {
      ${checkboxStyles(theme, 'focus')}
    }

    &:active ~ ${CheckboxStyled} {
      ${checkboxStyles(theme, 'active')}

      ${CheckboxIcon} {
        display: block;
      }
    }

    &:checked ~ ${CheckboxStyled} {
      ${checkboxStyles(theme, 'selected')}

      ${CheckboxIcon} {
        display: block;
      }
    }

    &[readonly]:checked ~ ${CheckboxStyled} {
      ${checkboxStyles(theme, 'selectedReadonly')}
    }

    &[readonly]:hover
      ~ ${CheckboxStyled},
      &[readonly]:active
      ~ ${CheckboxStyled},
      &:disabled:hover
      ~ ${CheckboxStyled},
      &:disabled:active
      ~ ${CheckboxStyled} {
      box-shadow: none;
    }

    &:disabled,
    &:disabled ~ ${ParagraphMd} {
      cursor: not-allowed;
      color: ${theme.olist.components.checkbox.label.color.disabled};
    }

    &[readonly],
    &[readonly] ~ ${ParagraphMd} {
      cursor: default;
      color: ${theme.olist.components.checkbox.label.color.rest};
    }

    &:disabled ~ ${CheckboxStyled} {
      ${checkboxStyles(theme, 'disabled')}
      ${CheckboxIcon} {
        display: none;
      }
    }
    &:disabled:checked ~ ${CheckboxStyled} {
      ${checkboxStyles(theme, 'selectedDisabled')}
      ${CheckboxIcon} {
        display: block;
      }
    }

    ${error &&
    css `
      &:hover ~ ${CheckboxStyled}, & ~ ${CheckboxStyled} {
        ${checkboxStyles(theme, 'error')}
      }

      &:active ~ ${CheckboxStyled} {
        ${checkboxStyles(theme, 'active')}
        ${CheckboxIcon} {
          display: block;
        }
      }

      &:checked ~ ${CheckboxStyled} {
        ${checkboxStyles(theme, 'selectedError')}
      }

      &:checked&:active ~ ${CheckboxStyled} {
        ${CheckboxIcon} {
          display: block;
        }
      }

      &:disabled ~ ${CheckboxStyled} {
        ${checkboxStyles(theme, 'disabled')}
      }
    `}

    ${indeterminate &&
    css `
      &
        ~ ${CheckboxStyled},
        &:hover
        ~ ${CheckboxStyled},
        &:focus
        ~ ${CheckboxStyled} {
        ${checkboxStyles(theme, 'indeterminate')}
        ${CheckboxIcon} {
          display: block;
        }
      }

      &:disabled ~ ${CheckboxStyled} {
        ${checkboxStyles(theme, 'indeterminateDisabled')}
        ${CheckboxIcon} {
          display: block;
        }
      }
    `}

    ${indeterminate &&
    error &&
    css `
      &
        ~ ${CheckboxStyled},
        &:hover
        ~ ${CheckboxStyled},
        &:focus
        ~ ${CheckboxStyled} {
        ${checkboxStyles(theme, 'selectedError')}
        ${CheckboxIcon} {
          display: block;
        }
      }
    `}
  `);
const Wrapper = styled.label(({ theme: { olist: { components: { checkbox }, }, }, }) => css `
    display: flex;
    position: relative;
    flex-direction: column;
    border-radius: ${checkbox.radius};

    ${Caption} {
      color: ${checkbox.caption.color};
    }

    ${margins}
  `);
const WrapperCheckbox = styled.span(({ disabled, readOnly, theme: { olist: { components: { checkbox }, }, }, }) => css `
    min-height: 44px;
    display: flex;
    align-items: center;
    cursor: pointer;

    ${disabled &&
    css `
      cursor: not-allowed;
    `}

    ${readOnly &&
    css `
      cursor: default;
    `}

    ${ParagraphMd} {
      margin-left: ${checkbox.label.margin};
      color: ${checkbox.label.color.rest};
    }
  `);

export { CheckboxStyled, Field, Wrapper, WrapperCheckbox };
